import React, { useState } from "react";
import { FaEnvelope, FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import bgImage from "../Images/cleaniing_two.jpg";
import axios from "axios";
import ToastNotification from "../components/ToastNotification/ToastNotification";
function AdminLogin({
  setIsAdmin
}) {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [toast, setToast] = useState({
    show: false,
    message: '',
    bg: 'success'
  });
  const showToast = (msg, bg = 'success') => {
    setToast({
      show: true,
      message: msg,
      bg
    });
  };
  const handleLogin = async () => {
    setError("");
    if (!email || !password) {
      showToast("Please enter email and password", 'warning');
      return;
    }
    try {
      const response = await axios.put("https://api.sweepydo.in/admin-login", {
        mobile: email,
        pass: password
      });
      const user = response.data;
      if (user) {
        localStorage.setItem("isAdmin", "true");
        setIsAdmin(true);
        // Correct way to store the whole user object

        localStorage.setItem("userData", JSON.stringify(response.data));
        showToast("Login Successful!", 'success');
        setTimeout(() => {
          navigate("/admin/admin-dashboard");
        }, 1500);
      }
    } catch (err) {
      console.error("Login error:", err.response?.data || err.message);
      if (err.response && err.response.data && err.response.data.message) {
        showToast(err.response.data.message, 'danger');
      } else {
        showToast("Login failed. Please try again.", 'danger');
      }
    }
  };
  return <div className="d-flex justify-content-center align-items-center vh-100" style={{
    backgroundImage: `url(${bgImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center"
  }}>

             <ToastNotification show={toast.show} message={toast.message} bg={toast.bg} onClose={() => setToast({
      ...toast,
      show: false
    })} />
      <div className="p-5 text-white" style={{
      width: "450px",
      borderRadius: "20px",
      backdropFilter: "blur(15px)",
      background: "rgba(255, 255, 255, 0.15)",
      boxShadow: "0 8px 32px rgba(0,0,0,0.3)"
    }}>
        <h2 className="text-center mb-4 fw-bold text-primary">ADMIN LOGIN</h2>

        {error && <p className="text-danger text-center">{error}</p>}

        <div className="mb-4 position-relative">
          <input type="text" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} className="form-control bg-transparent text-white border-0 border-bottom rounded-0" style={{
          outline: "none",
          boxShadow: "none"
        }} />
          <FaEnvelope style={{
          position: "absolute",
          right: "10px",
          top: "50%",
          transform: "translateY(-50%)",
          color: "black"
        }} />
        </div>

        <div className="mb-2 position-relative">
          <input type={showPassword ? "text" : "password"} placeholder="Password" value={password} onChange={e => setPassword(e.target.value)} className="form-control bg-transparent text-white border-0 border-bottom rounded-0 pe-5" style={{
          outline: "none",
          boxShadow: "none"
        }} />
          <FaLock style={{
          position: "absolute",
          right: "35px",
          top: "50%",
          transform: "translateY(-50%)",
          color: "black"
        }} />
          {showPassword ? <FaEyeSlash onClick={() => setShowPassword(false)} style={{
          position: "absolute",
          right: "10px",
          top: "50%",
          transform: "translateY(-50%)",
          cursor: "pointer",
          color: "black"
        }} /> : <FaEye onClick={() => setShowPassword(true)} style={{
          position: "absolute",
          right: "10px",
          top: "50%",
          transform: "translateY(-50%)",
          cursor: "pointer",
          color: "black"
        }} />}
        </div>

        <div className="mt-5">
          <button onClick={handleLogin} className="btn w-100 text-white" style={{
          borderRadius: "25px",
          background: "linear-gradient(to right, #6a11cb, #2575fc)",
          border: "none"
        }}>
            Login
          </button>
        </div>
      </div>
    </div>;
}
export default AdminLogin;
